import * as React from "react";
import { Sparkles } from "lucide-react";

import { Media, VideoProjectStatus, VideoProjectDetail } from "@/interfaces";
import { VideoProjectUploader } from "@/components/VideoProjectUploader";
import { VideosSection } from "@/components/Forms/VideoProjectDetail/components/VideosSection";

interface Props {
  videoProject: VideoProjectDetail;
  handleMediaUpdated: (newMedia: Media[]) => void;
}

export const EditorFinalEdit: React.FC<Props> = ({ videoProject, handleMediaUpdated }) => {
  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex flex-row justify-between items-center w-full select-none">
          <label className="sectionHeader font-semibold text-slate-800 text-sm flex items-center gap-1.5">
            <Sparkles className="size-4.5 text-blue-600" />
            Final Edit
          </label>
        </div>
        <div className="videoProjectContainer flex flex-col gap-4 bg-slate-50/50 p-5 rounded-xl border border-slate-200 w-full">
          {/* Edited Files section */}
          {videoProject.status === VideoProjectStatus.POSTED ? (
            <VideosSection
              type="EDITED"
              videos={videoProject.editedMedia?.media!!}
              videoProjectId={videoProject.videoProjectId!!}
              isEditor={true}
              cols={2}
            />
          ) : (
            <VideoProjectUploader
              editedFile={true}
              handleMediaUpdated={handleMediaUpdated}
              originalMedia={videoProject.editedMedia?.media || []}
              projectId={videoProject.videoProjectId}
            />
          )}
        </div>
      </div>
    </>
  );
};
